import React, { useEffect } from "react";
import Home from "./pages/home/Home";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { productInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import SignIn from "./components/login/login";
import Product from "./pages/product/product";
import PatientContainer from "./pages/Patient/PatientContainer";
import BasicInfo from "./pages/Patient/basicInfoContainer";
import DiagnosisContainer from "./pages/Patient/diagnosisContainer";
import VitalParameterContainer from "./pages/Patient/vitalParameterContainer";
import LifestyleContainer from "./pages/Patient/lifestyleContainer";
import MedicalHistoryContainer from "./pages/Patient/MedicalHistoryContainer";
import InsuranceInformationContainer from "./pages/Patient/insuranceContainer";
import CorporateDetailsContainer from "./pages/Patient/corporateDetailsContainer";
import BillingDetailsContainer from "./pages/Patient/billingContainer";
import AttendantDetailsContainer from "./pages/Patient/attendantContainer";
import FamilyHistoryContainer from "./pages/Patient/familyHistoryContainer";
import { ToastContainer } from 'react-toastify';
import OPDContainer from "./pages/Patient/opContainer";
import MyProfileContainer from "./pages/Myprofile/myProfileContainer";
import BranchContainer from "./pages/master/branch/branchContainer";
import DoctorContainer from "./pages/master/doctor/doctorContainer";
import DepartmentContainer from "./pages/master/department/departmentContainer";
import DiagnosisPatientContainer from "./pages/master/diagnosis/diagnosisContainer";
import PatientByIDContainer from "./pages/Patient/patientByIdContainer";
import * as AuthInterceptor from "./service/auth-interceptor/AuthInterceptor.service";
import PatientRecieveFeeContainer from "./pages/Patient/PatientRecieveFeeContainer";
import PathalogyContainer from "./pages/Pathalogy/pathalogyContainer";
import BranchListContainer from "./pages/master/branch/branchListContainer";
import DepartmentListContainer from "./pages/master/department/departmentListContainer";
import DiagnosisListContainer from "./pages/master/diagnosis/diagnosisListContainer";
import DoctorListContainer from "./pages/master/doctor/doctorListContainer";
import { PrivateRoute } from "./PrivateRoutes";
import OPDTableContainer from "./pages/OPD/opContainer";
import IpdContainer from "./pages/Ipd/ipdContainer";
import IpdRegisterContainer from "./pages/Ipd/ipdRegisterContainer";
import RoomTypeContainer from "./pages/master/roomType/roomTypeContainer";
import RoomTypeTableContainer from "./pages/master/roomType/roomTypeTableContainer";
import WardContainer from "./pages/master/ward/wardContainer";
import AddWardContainer from "./pages/master/ward/addWardContainer";
import BedTableContainer from "./pages/master/bed/bedTableContainer";
import AddBedContainer from "./pages/master/bed/addBedContainer";
import InusranceTableContainer from "./pages/master/insurance/insuranceTableContainer";
import AddInusranceContainer from "./pages/master/insurance/addinsuranceContainer";
import BlockedInsuranceContainer from "./pages/Accounts/blockedInsurance/blockedInsuranceContainer";
import AddVoucherContainer from "./pages/Ipd/voucher/addVoucherContainer";
import IpdReleaseContainer from "./pages/Ipd/ipdRelease/ipdReleaseContainer";
import ReportsContainer from "./pages/reports/reportsContainer";
import OPDReportsContainer from "./pages/OPD/opdReports/opdReportsContainer";
import AddUserContainer from "./pages/master/user/addUserContainer";
import LabRequestContainer from "./pages/Pathalogy/labRequest/labRequestContainer";
import LabEnteryTableContainer from "./pages/Pathalogy/labEntery/labEnteryContainer";
import AddLabEnteryContainer from "./pages/Pathalogy/labEntery/addLabEnteryContainer";

AuthInterceptor.init();

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))

  useEffect(() => {
    const checkTenantId = () => {
      if (!getUserValue?.tenantId || getUserValue?.tenantId === null) {
        return <Navigate path="/" />
      }
    }
    checkTenantId()
  }, [getUserValue?.tenantId || getUserValue?.tenantId === null])

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate replace to="/login" />} />
          <Route index path="/login" element={<SignIn />}>
          </Route>
          <Route path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            } />
          <Route
            path="/opd"
            element={
              <PrivateRoute>
                <OPDContainer />
              </PrivateRoute>
            }
          />
          <Route
            path="/opd-list"
            element={
              <PrivateRoute>
                <OPDTableContainer />
              </PrivateRoute>
            }
          />
            <Route
            path="/home/reports"
            element={
              <PrivateRoute>
                <OPDReportsContainer />
              </PrivateRoute>
            }
          />
          
          
          {/* <Route
            path="/ipd-release"
            element={
              <PrivateRoute>
                <IpdReleaseContainer />
              </PrivateRoute>
            }
          /> */}

          <Route
            path="/pathalogy"
            element={
              <PrivateRoute>
                <PathalogyContainer />
              </PrivateRoute>
            }
          />

          <Route
            path="/patient-recieve-fee"
            element={
              <PrivateRoute>
                <PatientRecieveFeeContainer />
              </PrivateRoute>

            }
          />

          <Route
            path="/my-profile"
            element={
              <PrivateRoute>
                <MyProfileContainer />
              </PrivateRoute>
            }
          />
          <Route
            path="/opd/:id"
            element={
              <PrivateRoute>
                <OPDContainer />
              </PrivateRoute>
            }
          />
          <Route path="/patient-registration">
            <Route index element={
              <PrivateRoute>
                <PatientContainer />
              </PrivateRoute>
            } />
            <Route
              path="basic-information"
              element={
                <PrivateRoute>
                  <BasicInfo />
                </PrivateRoute>
              }
            />
            <Route
              path="diagnosis"
              element={
                <PrivateRoute>
                  <DiagnosisContainer />
                </PrivateRoute>
              }
            />
            <Route
              path="vital-parmeter"
              element={
                <PrivateRoute>
                  <VitalParameterContainer />
                </PrivateRoute>

              }
            />
            <Route
              path="lifestyle"
              element={<LifestyleContainer />}
            />
            <Route
              path="medical-history"
              element={<MedicalHistoryContainer />}
            />
            <Route
              path="insurance"
              element={<InsuranceInformationContainer />}
            />
            <Route
              path="corporate-details"
              element={<CorporateDetailsContainer />}
            />
            <Route
              path="billing-info"
              element={<BillingDetailsContainer />}
            />
            <Route
              path="attendant"
              element={<AttendantDetailsContainer />}
            />
            <Route
              path="family-history"
              element={<FamilyHistoryContainer />}
            />
            <Route
              path="patient-id"
              element={<PatientByIDContainer />}
            />
          </Route>
          <Route path="products">
            <Route index element={<Product />} />
            <Route path=":productId" element={<Single />} />
            <Route
              path="new"
              element={<New inputs={productInputs} title="Add New Product" />}
            />
          </Route>
          <Route path="master">
            <Route index path="branch" element={
              <PrivateRoute>
                <BranchListContainer />
              </PrivateRoute>
            } />
            <Route path="add-branch" element={<BranchContainer />} />
            <Route path="department" element={<DepartmentListContainer />} />
            <Route path="add-department" element={<DepartmentContainer />} />
            <Route path="diagnosis" element={<DiagnosisListContainer />} />
            <Route path="add-diagnosis" element={<DiagnosisPatientContainer />} />
            <Route path="doctor" element={<DoctorListContainer />} />
            <Route path="add-doctor" element={<DoctorContainer />} />
            <Route path="room-type-table" element={<RoomTypeTableContainer />} />
            <Route path="add-room-type" element={<RoomTypeContainer />} />
            <Route path="ward-list" element={<WardContainer />} />
            <Route path="add-ward" element={<AddWardContainer />} />
            <Route path="bed-list" element={<BedTableContainer />} />
            <Route path="add-bed" element={<AddBedContainer />} />
            <Route path="insurance-list" element={<InusranceTableContainer />} />
            <Route path="add-insurance" element={<AddInusranceContainer />} />
            <Route path="add-user" element={<AddUserContainer />} />
            

            {/*  */}
            {/* WardContainer */}
          </Route>
          <Route path="accounts">
            <Route path="blocked-insurance" element={<BlockedInsuranceContainer />} />
            <Route path="ipd-approval" element={<IpdReleaseContainer />} />
          </Route>
          <Route path="pathology">
            <Route path="lab-request" element={<LabRequestContainer />} />
            <Route path="lab-entery" element={<LabEnteryTableContainer />} />
            <Route path="add-lab-entery" element={<AddLabEnteryContainer />} />
            
          </Route>

          <Route path="/ipd" element={<IpdContainer />} />
          <Route path="/register" element={<IpdRegisterContainer />} />
          <Route path="/add-voucher" element={<AddVoucherContainer />} />
          <Route path="reports">
            <Route path="inpatient-status-report" element={<ReportsContainer />} />
          </Route>
          {/* LabRequestContainer */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
